import { useTranslation } from 'react-i18next';
import type { FaceDetectResult } from '@modules/dashboard/pages/kyc/docs-verification/docs-verification-page/tabs/selfie/liveness/step/liveness-process/types';
import { VerificationStatusEnum } from '@modules/dashboard/pages/kyc/docs-verification/docs-verification-page/tabs/selfie/liveness/step/liveness-process/types';

import type { ModelCheckError } from '../hints/types';

type UseLivenessErrorTextParams = {
    faceDetectResult: FaceDetectResult | null;
    verificationStatus: VerificationStatusEnum | null;
    currentError?: ModelCheckError;
    fileErrorCode?: number;
    prepareSeconds: number;
};

export const errorTranslationByType: Record<ModelCheckError, string> = {
    lowQuantity: 'docVerificationWidget.liveness.lowQuantity',
    highIllumination: 'docVerificationWidget.liveness.tooBright',
    lowIllumination: 'docVerificationWidget.liveness.tooDark',
    eyeClosed: 'docVerificationWidget.liveness.eyesNotDetected',
};

export const useLivenessErrorText = ({
    faceDetectResult,
    verificationStatus,
    currentError,
    fileErrorCode,
    prepareSeconds,
}: UseLivenessErrorTextParams): string | null => {
    const { t, i18n } = useTranslation();

    if (prepareSeconds) {
        return null;
    }

    if (
        verificationStatus === VerificationStatusEnum.FILE_ERROR &&
        fileErrorCode !== undefined
    ) {
        const translationKey = `docVerificationWidget.errors.${fileErrorCode}`;

        return i18n.exists(translationKey)
            ? t(translationKey)
            : t('docVerificationWidget.verificationError.subTitle');
    }

    if (verificationStatus === VerificationStatusEnum.FACE_NOT_FOUND) {
        return t('docVerificationWidget.liveness.faceNotInFrame');
    }

    if (faceDetectResult?.isFaceFound && currentError) {
        return t(errorTranslationByType[currentError]);
    }

    if (verificationStatus === VerificationStatusEnum.POOR_LIGHTING) {
        return t('docVerificationWidget.liveness.lightError');
    }

    return null;
};
